export const heroImage =
  "https://readdy.ai/api/search-image?query=cozy%20manga%20library%20reading%20room%20with%20tall%20wooden%20bookshelves%20filled%20with%20colorful%20comic%20volumes%2C%20warm%20afternoon%20sunlight%20streaming%20through%20large%20windows%2C%20inviting%20relaxed%20atmosphere%2C%20wide%20angle%20shot%2C%20anime%20illustration%20style%2C%20high%20detail%2C%20harmonious%20warm%20tones%2C%20no%20text&width=1600&height=900&seq=hero-baozi-manga-room&orientation=landscape";

export const heroStats = [
  { value: "12,800+", label: "收录漫画作品" },
  { value: "320 话", label: "日均更新话数" },
  { value: "180 万", label: "周活跃读者" },
];

export const heroQuickLinks = [
  { label: "看人气榜", href: "#ranking", icon: "ri-trophy-line" },
  { label: "追分类新番", href: "#new", icon: "ri-flashlight-line" },
  { label: "按题材筛选", href: "#explore", icon: "ri-filter-3-line" },
];

export type RankingItem = {
  rank: number;
  title: string;
  author: string;
  category: string;
  score: number;
  readers: string;
  status: string;
  tags: string[];
  desc: string;
  cover: string;
};

export const rankingList: RankingItem[] = [
  {
    rank: 1,
    title: "星轨拾荒者",
    author: "沈砚",
    category: "科幻 · 冒险",
    score: 9.7,
    readers: "128.4 万",
    status: "连载中",
    tags: ["太空", "群像", "热血"],
    desc: "在被废弃的星港里，拾荒少女意外唤醒一枚会说话的黑匣子，从此卷进横跨三个星系的秘辛。宏大的世界观配上克制的叙事节奏，被读者称为近两年最耐看的科幻长篇。",
    cover:
      "https://readdy.ai/api/search-image?query=young%20female%20scavenger%20exploring%20a%20derelict%20space%20station%20corridor%2C%20glowing%20nebula%20visible%20through%20cracked%20window%2C%20floating%20dust%20particles%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-star-scavenger&orientation=portrait",
  },
  {
    rank: 2,
    title: "山海食肆",
    author: "白鹿岐",
    category: "美食 · 奇幻",
    score: 9.5,
    readers: "96.2 万",
    status: "连载中",
    tags: ["治愈", "上古神兽", "经营"],
    desc: "一间开在山海交界处的小食肆，招待的都是上古神兽。老板只做一碗热汤，却能解开心结。每话一个客人的故事，读完总想立刻去吃夜宵。",
    cover:
      "https://readdy.ai/api/search-image?query=cheerful%20chef%20grilling%20skewers%20in%20a%20mythical%20fantasy%20tavern%2C%20warm%20lantern%20glow%2C%20small%20cute%20spirit%20creatures%20nearby%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-mountain-feast&orientation=portrait",
  },
  {
    rank: 3,
    title: "春日不安",
    author: "林一栖",
    category: "青春 · 恋爱",
    score: 9.3,
    readers: "87.5 万",
    status: "连载中",
    tags: ["校园", "暗恋", "细腻"],
    desc: "转学生和班长同坐一学期，从互相看不顺眼到谁都不肯先说出口。没有轰轰烈烈，只有被放大的心跳和沉默，把青春期那种悬而未决的感觉画得很准。",
    cover:
      "https://readdy.ai/api/search-image?query=high%20school%20girl%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20floating%20in%20the%20air%2C%20wistful%20gentle%20expression%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-spring-unease&orientation=portrait",
  },
  {
    rank: 4,
    title: "第七档案室",
    author: "陆时",
    category: "悬疑 · 推理",
    score: 9.4,
    readers: "79.8 万",
    status: "连载中",
    tags: ["本格", "反转", "单元剧"],
    desc: "一间只受理「无法归档」案件的档案室，每个案子独立成篇又暗线相连。推理逻辑扎实，反转基本不靠巧合，喜欢动脑的读者别错过。",
    cover:
      "https://readdy.ai/api/search-image?query=sharp%20eyed%20detective%20examining%20folders%20in%20a%20dim%20cluttered%20archive%20room%2C%20single%20desk%20lamp%20glow%2C%20film%20noir%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-archive-room&orientation=portrait",
  },
  {
    rank: 5,
    title: "剑鸣九州",
    author: "秦关",
    category: "热血 · 武侠",
    score: 9.2,
    readers: "112.3 万",
    status: "连载中",
    tags: ["江湖", "成长", "群像"],
    desc: "少年持一把不出鞘的剑闯江湖，一心想查清师门旧案。战斗分镜干净利落，配角各有立场，是近年武侠题材里少见的稳扎稳打。",
    cover:
      "https://readdy.ai/api/search-image?query=determined%20young%20swordsman%20swinging%20a%20long%20blade%2C%20flowing%20robes%2C%20dawn%20light%20on%20a%20mountain%20cliff%2C%20dynamic%20action%20pose%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-sword-jiuzhou&orientation=portrait",
  },
  {
    rank: 6,
    title: "猫与旧书店",
    author: "温叙",
    category: "日常 · 治愈",
    score: 9.1,
    readers: "64.7 万",
    status: "已完结",
    tags: ["治愈", "猫", "慢生活"],
    desc: "老街尽头一间旧书店，店主和一只赖着不走的橘猫，迎来送往形形色色的客人。全篇没有反派，节奏很慢，适合睡前看两话。",
    cover:
      "https://readdy.ai/api/search-image?query=girl%20reading%20beside%20a%20sleeping%20orange%20cat%20in%20a%20cozy%20old%20bookstore%2C%20warm%20afternoon%20light%2C%20tall%20wooden%20shelves%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-cat-bookstore&orientation=portrait",
  },
  {
    rank: 7,
    title: "深海回声",
    author: "顾寒声",
    category: "科幻 · 悬疑",
    score: 9.3,
    readers: "71.5 万",
    status: "连载中",
    tags: ["深海", "惊悚", "悬念"],
    desc: "一支科考队潜入从未被记录的海沟，听见了不属于任何已知生物的「回声」。压迫感从头到尾没有松过，画面色调克制又冷冽。",
    cover:
      "https://readdy.ai/api/search-image?query=diver%20floating%20in%20deep%20ocean%20surrounded%20by%20glowing%20bioluminescent%20jellyfish%2C%20dark%20teal%20water%2C%20mysterious%20atmosphere%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-deep-sea-echo&orientation=portrait",
  },
  {
    rank: 8,
    title: "篮球终场哨",
    author: "陈野",
    category: "运动 · 热血",
    score: 9.0,
    readers: "93.1 万",
    status: "连载中",
    tags: ["竞技", "团队", "燃"],
    desc: "一群被解散又重组的校队，从打不进区赛一路拼到全国舞台。比赛分镜很有张力，也没有回避失败，青春味十足。",
    cover:
      "https://readdy.ai/api/search-image?query=basketball%20player%20leaping%20for%20a%20slam%20dunk%20under%20arena%20spotlights%2C%20sweat%20and%20motion%20blur%2C%20energetic%20dynamic%20pose%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-basketball-buzzer&orientation=portrait",
  },
  {
    rank: 9,
    title: "幻夜棋局",
    author: "无咎",
    category: "奇幻 · 智斗",
    score: 9.2,
    readers: "58.3 万",
    status: "连载中",
    tags: ["智斗", "奇幻", "设定党"],
    desc: "深夜降临的棋盘城中，输掉棋局的人会被抹去存在。规则严密、每局都有新变化，是设定党会反复推敲的那类作品。",
    cover:
      "https://readdy.ai/api/search-image?query=mysterious%20hooded%20figure%20moving%20pieces%20on%20a%20glowing%20magical%20chessboard%2C%20floating%20candles%2C%20fantasy%20night%20setting%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-phantom-chess&orientation=portrait",
  },
  {
    rank: 10,
    title: "隔墙有耳",
    author: "苏打",
    category: "恋爱 · 喜剧",
    score: 8.9,
    readers: "66.9 万",
    status: "连载中",
    tags: ["日常", "搞笑", "邻里"],
    desc: "两个作息完全相反的邻居，靠着隔着一堵墙的声音逐渐熟悉。笑点密集，偶尔又甜得猝不及防。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20neighbors%20chatting%20from%20opposite%20apartment%20balconies%20at%20dusk%2C%20laundry%20lines%2C%20warm%20comedic%20slice%20of%20life%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-thin-walls&orientation=portrait",
  },
];

export type ReleaseItem = {
  title: string;
  author: string;
  chapter: string;
  frequency: string;
  tags: string[];
  desc: string;
  cover: string;
};

export type ReleaseTab = {
  key: string;
  label: string;
  intro: string;
  items: ReleaseItem[];
};

export const newReleaseTabs: ReleaseTab[] = [
  {
    key: "hot",
    label: "热血 · 冒险",
    intro: "少年、拳头与远方。这一档主打高强度的成长线和爽快对战，更新节奏普遍偏快，适合想找「一口气看半天」的读者。",
    items: [
      {
        title: "铁拳黎明",
        author: "江彻",
        chapter: "更新至第 42 话",
        frequency: "每周二 / 五更新",
        tags: ["拳击", "逆袭"],
        desc: "退役拳手在破旧拳馆里教出问题少年，两人从互不信任到并肩站上擂台。训练细节写得很认真，燃点来得扎实。",
        cover:
          "https://readdy.ai/api/search-image?query=boxer%20with%20bandaged%20fists%20standing%20in%20an%20empty%20boxing%20ring%20at%20dawn%2C%20dramatic%20rim%20light%2C%20resolute%20expression%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-iron-fist&orientation=portrait",
      },
      {
        title: "烽火少年志",
        author: "霍青",
        chapter: "更新至第 28 话",
        frequency: "每周日更新",
        tags: ["战争", "家国"],
        desc: "乱世里一个放牛少年被卷入战局，从只想活下去，到扛起一面旗。基调沉重但不过分煽情，配角群像立得住。",
        cover:
          "https://readdy.ai/api/search-image?query=young%20warrior%20holding%20a%20tattered%20banner%20on%20a%20battle%20scarred%20hill%2C%20embers%20floating%20in%20the%20air%2C%20epic%20historical%20feel%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-fire-youth&orientation=portrait",
      },
      {
        title: "少年御兽师",
        author: "牧野",
        chapter: "更新至第 17 话",
        frequency: "每周三更新",
        tags: ["驯兽", "奇幻"],
        desc: "能听懂兽语的少年踏上旅途，寻找失散的伙伴。画风明快，世界观轻松，适合作为热血题材的入门作。",
        cover:
          "https://readdy.ai/api/search-image?query=boy%20standing%20beside%20a%20large%20friendly%20beast%20companion%20in%20a%20green%20misty%20valley%2C%20morning%20light%2C%20adventurous%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-beast-tamer&orientation=portrait",
      },
    ],
  },
  {
    key: "love",
    label: "恋爱 · 日常",
    intro: "不赶时间的那一档。细水长流的相处、克制的甜，还有大量让人觉得「这不就是我吗」的生活细节，适合晚上翻两话放松。",
    items: [
      {
        title: "咖啡与月见草",
        author: "简宁",
        chapter: "更新至第 33 话",
        frequency: "每周一 / 四更新",
        tags: ["都市", "慢热"],
        desc: "开在巷口的小咖啡馆，老板记得每位常客的口味。故事跟着四季走，讲的是熟客们各自的心事与靠近。",
        cover:
          "https://readdy.ai/api/search-image?query=barista%20girl%20handing%20a%20latte%20to%20a%20customer%20in%20a%20cozy%20cafe%2C%20rainy%20window%2C%20soft%20warm%20ambience%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-coffee-evening&orientation=portrait",
      },
      {
        title: "心跳距离",
        author: "柯屿",
        chapter: "更新至第 25 话",
        frequency: "每周六更新",
        tags: ["校园", "双向暗恋"],
        desc: "两个成绩不相上下的人被安排成学习搭档，默契却总差临门一脚。分镜会玩小心思，很多情绪都藏在没说出口的画面里。",
        cover:
          "https://readdy.ai/api/search-image?query=two%20students%20sharing%20an%20umbrella%20on%20a%20rainy%20school%20path%2C%20blushing%20faces%2C%20romantic%20gentle%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-heartbeat&orientation=portrait",
      },
      {
        title: "隔壁的午餐",
        author: "米粒",
        chapter: "更新至第 19 话",
        frequency: "每周二更新",
        tags: ["美食", "邻里"],
        desc: "独自租房的女生的日常，从每天和邻居交换午餐开始。很轻很暖，每话都附一份可以照着做的小食谱。",
        cover:
          "https://readdy.ai/api/search-image?query=girl%20sharing%20a%20homemade%20bento%20with%20a%20neighbor%20on%20a%20sunny%20rooftop%2C%20cheerful%20everyday%20scene%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-lunch-nextdoor&orientation=portrait",
      },
    ],
  },
  {
    key: "mystery",
    label: "悬疑 · 推理",
    intro: "需要一部看到最后才敢下结论的作品？这一档偏重线索铺陈和气氛营造，建议一口气追到揭晓，别提前翻评论。",
    items: [
      {
        title: "雾港谜案",
        author: "池舟",
        chapter: "更新至第 30 话",
        frequency: "每周五更新",
        tags: ["本格", "凶案"],
        desc: "港口小城接连发生怪案，退休警探被迫重返一线。线索公平地摆在读者面前，是那种会想拿纸笔记笔记的类型。",
        cover:
          "https://readdy.ai/api/search-image?query=detective%20in%20a%20trench%20coat%20walking%20through%20a%20foggy%20harbor%20at%20night%2C%20glowing%20lamp%20posts%2C%20suspenseful%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-fog-harbor&orientation=portrait",
      },
      {
        title: "第十三名乘客",
        author: "岑野",
        chapter: "更新至第 22 话",
        frequency: "每周三更新",
        tags: ["密室", "惊悚"],
        desc: "末班公交车上只剩十二个座位，却数出了十三个人。节奏快、章节短，压迫感像慢慢收紧的绳子。",
        cover:
          "https://readdy.ai/api/search-image?query=empty%20night%20bus%20interior%20with%20one%20mysterious%20seated%20figure%2C%20eerie%20green%20light%2C%20thriller%20atmosphere%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-thirteenth-passenger&orientation=portrait",
      },
      {
        title: "无声证词",
        author: "闻笙",
        chapter: "更新至第 14 话",
        frequency: "每周日更新",
        tags: ["法医", "纪实感"],
        desc: "法医视角的单元案件，重点不在凶手多狡猾，而在证据如何一点点说话。细节考究，冷静但有温度。",
        cover:
          "https://readdy.ai/api/search-image?query=forensic%20investigator%20examining%20clues%20under%20police%20tape%2C%20cold%20rainy%20street%20at%20night%2C%20procedural%20crime%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-silent-witness&orientation=portrait",
      },
    ],
  },
  {
    key: "fantasy",
    label: "奇幻 · 古风",
    intro: "架空世界与东方志怪并行。这一档重设定、重画面，很多作品一开场就是一张值得当壁纸的跨页，收藏党会很喜欢。",
    items: [
      {
        title: "龙脊编年",
        author: "朔风",
        chapter: "更新至第 36 话",
        frequency: "每周一 / 五更新",
        tags: ["龙骑", "史诗"],
        desc: "龙族与人族千年盟约将碎，一名低阶龙骑被推到风口浪尖。世界观庞大但交代得清楚，设定党友好。",
        cover:
          "https://readdy.ai/api/search-image?query=young%20dragon%20rider%20soaring%20above%20ancient%20mountain%20ridges%2C%20sweeping%20clouds%2C%20epic%20fantasy%20scene%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-dragon-spine&orientation=portrait",
      },
      {
        title: "幽都行商",
        author: "漆园",
        chapter: "更新至第 20 话",
        frequency: "每周四更新",
        tags: ["志怪", "东方"],
        desc: "推着货车的商人在人鬼交界的小镇做买卖，用货物换故事。文风古朴，插画般的分镜像旧画本。",
        cover:
          "https://readdy.ai/api/search-image?query=traveling%20merchant%20with%20a%20lantern%20cart%20entering%20a%20lantern%20lit%20ancient%20spirit%20town%2C%20mystical%20fog%2C%20oriental%20fantasy%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-ghost-merchant&orientation=portrait",
      },
      {
        title: "星陨法师",
        author: "琥珀",
        chapter: "更新至第 11 话",
        frequency: "每周六更新",
        tags: ["魔法", "冒险"],
        desc: "魔法正在从世界上消失，一名法师带着最后的咒语去寻找原因。开篇不算惊艳，但后劲很足，属于越看越上头的类型。",
        cover:
          "https://readdy.ai/api/search-image?query=mage%20casting%20a%20spell%20as%20a%20meteor%20shower%20falls%20over%20a%20ruined%20tower%2C%20glowing%20magic%20light%2C%20dramatic%20fantasy%20scene%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-starfall-mage&orientation=portrait",
      },
    ],
  },
];

export type EditorPick = {
  title: string;
  author: string;
  category: string;
  note: string;
  readTime: string;
  cover: string;
};

export const editorPicks: EditorPick[] = [
  {
    title: "山海食肆",
    author: "白鹿岐",
    category: "美食 · 奇幻",
    note: "它大概是榜单里最「不着急」的一部。别人在打怪升级，它只是认真炖一锅汤。但正因为慢，那些关于遗憾与和解的段落才有时间沉淀下来。适合每一次心情低落的深夜。",
    readTime: "全 18 卷 · 单话约 8 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=cheerful%20chef%20grilling%20skewers%20in%20a%20mythical%20fantasy%20tavern%2C%20warm%20lantern%20glow%2C%20small%20cute%20spirit%20creatures%20nearby%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-mountain-feast&orientation=portrait",
  },
  {
    title: "第七档案室",
    author: "陆时",
    category: "悬疑 · 推理",
    note: "推荐给喜欢自己破案的读者。作者把关键线索都摊在明面上，不靠隐藏信息制造反转，所以当你终于想通的一刻，会有种被尊重的爽感。单元剧结构对新手也很友好。",
    readTime: "已更新 46 话 · 单话约 10 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=sharp%20eyed%20detective%20examining%20folders%20in%20a%20dim%20cluttered%20archive%20room%2C%20single%20desk%20lamp%20glow%2C%20film%20noir%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-archive-room&orientation=portrait",
  },
  {
    title: "春日不安",
    author: "林一栖",
    category: "青春 · 恋爱",
    note: "如果你早就看腻了「三话确定关系」的甜宠，这部会重新让你记起暗恋是什么感觉。它最厉害的地方是克制——很多话就是不说出口，靠一个眼神、一次沉默把情绪顶上来。",
    readTime: "全 12 卷 · 单话约 6 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=high%20school%20girl%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20floating%20in%20the%20air%2C%20wistful%20gentle%20expression%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-spring-unease&orientation=portrait",
  },
];

export type ScheduleDay = {
  day: string;
  date: string;
  items: { title: string; chapter: string; category: string }[];
};

export const updateSchedule: ScheduleDay[] = [
  {
    day: "周一",
    date: "10/06",
    items: [
      { title: "咖啡与月见草", chapter: "第 33 话", category: "恋爱 · 日常" },
      { title: "龙脊编年", chapter: "第 36 话", category: "奇幻 · 古风" },
    ],
  },
  {
    day: "周二",
    date: "10/07",
    items: [
      { title: "铁拳黎明", chapter: "第 42 话", category: "热血 · 冒险" },
      { title: "隔壁的午餐", chapter: "第 19 话", category: "恋爱 · 日常" },
    ],
  },
  {
    day: "周三",
    date: "10/08",
    items: [
      { title: "少年御兽师", chapter: "第 17 话", category: "热血 · 冒险" },
      { title: "第十三名乘客", chapter: "第 22 话", category: "悬疑 · 推理" },
    ],
  },
  {
    day: "周四",
    date: "10/09",
    items: [
      { title: "幽都行商", chapter: "第 20 话", category: "奇幻 · 古风" },
      { title: "咖啡与月见草", chapter: "第 34 话", category: "恋爱 · 日常" },
    ],
  },
  {
    day: "周五",
    date: "10/10",
    items: [
      { title: "雾港谜案", chapter: "第 30 话", category: "悬疑 · 推理" },
      { title: "铁拳黎明", chapter: "第 43 话", category: "热血 · 冒险" },
      { title: "龙脊编年", chapter: "第 37 话", category: "奇幻 · 古风" },
    ],
  },
  {
    day: "周六",
    date: "10/11",
    items: [
      { title: "心跳距离", chapter: "第 25 话", category: "恋爱 · 日常" },
      { title: "星陨法师", chapter: "第 11 话", category: "奇幻 · 古风" },
    ],
  },
  {
    day: "周日",
    date: "10/12",
    items: [
      { title: "烽火少年志", chapter: "第 28 话", category: "热血 · 冒险" },
      { title: "无声证词", chapter: "第 14 话", category: "悬疑 · 推理" },
    ],
  },
];

export type TrendInsight = {
  icon: string;
  title: string;
  text: string;
  metric: string;
  metricLabel: string;
};

export const trendInsights: TrendInsight[] = [
  {
    icon: "ri-fire-line",
    title: "热血冒险回潮",
    text: "本季度热血冒险类新番占比升至 27%，比上季度提高 6 个百分点。读者对「长线成长」的耐心正在回来，单话完结的短篇热度有所回落。",
    metric: "+6%",
    metricLabel: "题材占比变化",
  },
  {
    icon: "ri-heart-3-line",
    title: "慢节奏恋爱站稳脚跟",
    text: "恋爱日常类虽然没有爆款冲到榜首，但「完读率」在全部题材里最高。换句话说，点进去的人往往愿意看到最后一话。",
    metric: "第 1 名",
    metricLabel: "完读率排名",
  },
  {
    icon: "ri-search-eye-line",
    title: "悬疑单元剧更好入口",
    text: "悬疑推理顶部作品中，采用单元剧结构的作品平均追更人数高出 18%。对还没入坑的读者来说，随时能看一话的结构降低了门槛。",
    metric: "+18%",
    metricLabel: "单元剧追更优势",
  },
  {
    icon: "ri-user-heart-line",
    title: "读者更信口碑而非宣传",
    text: "榜单前十中，有 7 部是靠读者评分在两个月内自然爬升上来的，而非开更即高位。评分与评论已经成为发现好作品的主要入口。",
    metric: "7 / 10",
    metricLabel: "口碑驱动占比",
  },
];

export type GuideStep = {
  step: string;
  title: string;
  text: string;
  icon: string;
};

export const guideSteps: GuideStep[] = [
  {
    step: "01",
    title: "先用榜单锁定方向",
    text: "不确定看什么，就先翻人气榜。榜单同时给出评分、题材和一句简介，可以先按封面和题材记下三五部，再逐个试读。",
    icon: "ri-list-check-2",
  },
  {
    step: "02",
    title: "按题材缩小范围",
    text: "往下到题材筛选区，点选你在意的标签（如「治愈」「智斗」），列表会即时过滤出符合的作品，比一页页翻要快得多。",
    icon: "ri-filter-3-line",
  },
  {
    step: "03",
    title: "对照更新日历安排追更",
    text: "更新日历按星期列出各作品的新话时间。把喜欢的那几部记下来，就能知道自己一周里哪天有得看，不用反复刷新。",
    icon: "ri-calendar-check-line",
  },
  {
    step: "04",
    title: "用编辑精选确认口味",
    text: "如果试读几部都不对味，可以看看编辑精选。那里不堆作品，只讲「为什么推荐」和适合什么心情看，帮你更快判断是否合口味。",
    icon: "ri-bookmark-3-line",
  },
];

export type FaqItem = {
  q: string;
  a: string;
};

export const faqList: FaqItem[] = [
  {
    q: "榜单的排名是怎么来的？",
    a: "榜单综合读者评分、追更人数与近期讨论热度计算，并会定期更新。它不是一次性评奖，而是持续滚动的动态排行，所以作品会随口碑变化上升或下降。",
  },
  {
    q: "「分类新番」和「人气榜」有什么区别？",
    a: "人气榜看的是整体热度，回答「大家在看什么」；分类新番更关注新开更和近期上新的作品，回答「最近有什么值得一试」。想追新就翻新番，想稳一点就看榜单。",
  },
  {
    q: "页面上的筛选和搜索会跳到别的页面吗？",
    a: "不会。所有的标签筛选和搜索都只作用在本页已经展示的作品上，结果会实时刷新在当前列表里，不会离开本页，也不需要注册或登录。",
  },
  {
    q: "为什么有的作品标着「已完结」？",
    a: "「已完结」表示这部作品的全篇内容已经出完，可以一次性看完整段故事，不用担心断更。喜欢从头补番的读者，可以直接优先看这一档。",
  },
  {
    q: "更新日历上的时间会变吗？",
    a: "部分作品的更新时间会因作者状态或节假日调整，因此日历给出的是常规节奏。如果某天没有如期更新，通常会在接下来几天内补上。",
  },
  {
    q: "这里收录的都是什么类型的作品？",
    a: "覆盖面较广，从热血冒险、恋爱日常，到悬疑推理、奇幻古风都有，既有长篇连载也有短篇单元剧。题材筛选区可以按你偏好的方向快速定位。",
  },
];

export const allTags = [
  "太空",
  "群像",
  "热血",
  "治愈",
  "上古神兽",
  "经营",
  "校园",
  "暗恋",
  "细腻",
  "本格",
  "反转",
  "单元剧",
  "江湖",
  "成长",
  "慢生活",
  "深海",
  "惊悚",
  "悬念",
  "竞技",
  "团队",
  "智斗",
  "设定党",
  "搞笑",
  "邻里",
];

export type ExploreItem = {
  title: string;
  author: string;
  category: string;
  score: string;
  tags: string[];
  status: string;
  cover: string;
};

export const exploreItems: ExploreItem[] = [
  {
    title: "星轨拾荒者",
    author: "沈砚",
    category: "科幻 · 冒险",
    score: "9.7",
    tags: ["太空", "群像", "热血"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=young%20female%20scavenger%20exploring%20a%20derelict%20space%20station%20corridor%2C%20glowing%20nebula%20visible%20through%20cracked%20window%2C%20floating%20dust%20particles%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-star-scavenger&orientation=portrait",
  },
  {
    title: "山海食肆",
    author: "白鹿岐",
    category: "美食 · 奇幻",
    score: "9.5",
    tags: ["治愈", "上古神兽", "经营"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=cheerful%20chef%20grilling%20skewers%20in%20a%20mythical%20fantasy%20tavern%2C%20warm%20lantern%20glow%2C%20small%20cute%20spirit%20creatures%20nearby%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-mountain-feast&orientation=portrait",
  },
  {
    title: "春日不安",
    author: "林一栖",
    category: "青春 · 恋爱",
    score: "9.3",
    tags: ["校园", "暗恋", "细腻"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=high%20school%20girl%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20soft%20pink%20petals%20floating%20in%20the%20air%2C%20wistful%20gentle%20expression%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-spring-unease&orientation=portrait",
  },
  {
    title: "第七档案室",
    author: "陆时",
    category: "悬疑 · 推理",
    score: "9.4",
    tags: ["本格", "反转", "单元剧"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=sharp%20eyed%20detective%20examining%20folders%20in%20a%20dim%20cluttered%20archive%20room%2C%20single%20desk%20lamp%20glow%2C%20film%20noir%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20professional%20digital%20art%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-archive-room&orientation=portrait",
  },
  {
    title: "剑鸣九州",
    author: "秦关",
    category: "热血 · 武侠",
    score: "9.2",
    tags: ["江湖", "成长", "群像"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=determined%20young%20swordsman%20swinging%20a%20long%20blade%2C%20flowing%20robes%2C%20dawn%20light%20on%20a%20mountain%20cliff%2C%20dynamic%20action%20pose%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-sword-jiuzhou&orientation=portrait",
  },
  {
    title: "猫与旧书店",
    author: "温叙",
    category: "日常 · 治愈",
    score: "9.1",
    tags: ["治愈", "慢生活"],
    status: "已完结",
    cover:
      "https://readdy.ai/api/search-image?query=girl%20reading%20beside%20a%20sleeping%20orange%20cat%20in%20a%20cozy%20old%20bookstore%2C%20warm%20afternoon%20light%2C%20tall%20wooden%20shelves%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-cat-bookstore&orientation=portrait",
  },
  {
    title: "深海回声",
    author: "顾寒声",
    category: "科幻 · 悬疑",
    score: "9.3",
    tags: ["深海", "惊悚", "悬念"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=diver%20floating%20in%20deep%20ocean%20surrounded%20by%20glowing%20bioluminescent%20jellyfish%2C%20dark%20teal%20water%2C%20mysterious%20atmosphere%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-deep-sea-echo&orientation=portrait",
  },
  {
    title: "篮球终场哨",
    author: "陈野",
    category: "运动 · 热血",
    score: "9.0",
    tags: ["竞技", "团队", "热血"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=basketball%20player%20leaping%20for%20a%20slam%20dunk%20under%20arena%20spotlights%2C%20sweat%20and%20motion%20blur%2C%20energetic%20dynamic%20pose%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-basketball-buzzer&orientation=portrait",
  },
  {
    title: "幻夜棋局",
    author: "无咎",
    category: "奇幻 · 智斗",
    score: "9.2",
    tags: ["智斗", "设定党"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=mysterious%20hooded%20figure%20moving%20pieces%20on%20a%20glowing%20magical%20chessboard%2C%20floating%20candles%2C%20fantasy%20night%20setting%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-phantom-chess&orientation=portrait",
  },
  {
    title: "隔墙有耳",
    author: "苏打",
    category: "恋爱 · 喜剧",
    score: "8.9",
    tags: ["搞笑", "邻里"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=two%20neighbors%20chatting%20from%20opposite%20apartment%20balconies%20at%20dusk%2C%20laundry%20lines%2C%20warm%20comedic%20slice%20of%20life%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=rank-thin-walls&orientation=portrait",
  },
  {
    title: "铁拳黎明",
    author: "江彻",
    category: "热血 · 冒险",
    score: "9.1",
    tags: ["竞技", "成长"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=boxer%20with%20bandaged%20fists%20standing%20in%20an%20empty%20boxing%20ring%20at%20dawn%2C%20dramatic%20rim%20light%2C%20resolute%20expression%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-iron-fist&orientation=portrait",
  },
  {
    title: "雾港谜案",
    author: "池舟",
    category: "悬疑 · 推理",
    score: "9.2",
    tags: ["本格", "悬念"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=detective%20in%20a%20trench%20coat%20walking%20through%20a%20foggy%20harbor%20at%20night%2C%20glowing%20lamp%20posts%2C%20suspenseful%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-fog-harbor&orientation=portrait",
  },
  {
    title: "咖啡与月见草",
    author: "简宁",
    category: "恋爱 · 日常",
    score: "9.0",
    tags: ["治愈", "慢生活"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=barista%20girl%20handing%20a%20latte%20to%20a%20customer%20in%20a%20cozy%20cafe%2C%20rainy%20window%2C%20soft%20warm%20ambience%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-coffee-evening&orientation=portrait",
  },
  {
    title: "幽都行商",
    author: "漆园",
    category: "奇幻 · 古风",
    score: "9.1",
    tags: ["上古神兽", "细腻"],
    status: "连载中",
    cover:
      "https://readdy.ai/api/search-image?query=traveling%20merchant%20with%20a%20lantern%20cart%20entering%20a%20lantern%20lit%20ancient%20spirit%20town%2C%20mystical%20fog%2C%20oriental%20fantasy%20mood%2C%20anime%20manga%20cover%20style%20illustration%2C%20clean%20simple%20minimalist%20background%2C%20vibrant%20cel%20shaded%20colors%2C%20high%20detail%2C%20no%20text&width=480&height=672&seq=new-ghost-merchant&orientation=portrait",
  },
];

export const navLinks = [
  { label: "人气榜", href: "#ranking" },
  { label: "分类新番", href: "#new" },
  { label: "编辑精选", href: "#picks" },
  { label: "更新日历", href: "#schedule" },
  { label: "题材筛选", href: "#explore" },
  { label: "常见问题", href: "#faq" },
];